import { Helmet } from 'react-helmet';
import NewdanhmuckhohangDetail
  from 'src/components/newdanhmuckhohang-detail/NewdanhmuckhohangDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmuckhohangListToolbar from '../components/newdanhmuckhohang-detail/NewdanhmuckhohangToolbar';

const Newdanhmuckhohang = () => (
  <>
    <Helmet>
      <title>Danh mục kho hàng</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmuckhohangListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmuckhohangDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmuckhohang;
